import { EntityInput, TroubleshootingComponentFamily, TroubleshootingSearchInputs } from './troubleshooting.datamodel';
import { FormGroup, Validators } from '@angular/forms';
import { ComponentType } from '../../publish/component/store/component.datamodel';
import { ActorType } from '../../shared/datamodel';

/**
 * Add validators to the form based on the selected entity type.
 * @param form Active form group
 */
export const formValidators = (form: FormGroup): Record<string, () => void> => {
  return {
    [TroubleshootingSearchInputs.product.type]: () => {
      form.get(TroubleshootingSearchInputs.product.type)?.addValidators(Validators.required);
    },
    [TroubleshootingSearchInputs.org.type]: () => {
      form.get(TroubleshootingSearchInputs.org.type)?.addValidators(Validators.required);
    },
    [TroubleshootingSearchInputs.ogu.type]: () => {
      form.get(TroubleshootingSearchInputs.ogu.type)?.addValidators(Validators.required);
      form.get(TroubleshootingSearchInputs.org.type)?.addValidators(Validators.required);
    },
    [TroubleshootingSearchInputs.office.type]: () => {
      form.get(TroubleshootingSearchInputs.office.type)?.addValidators(Validators.required);
    },
    [TroubleshootingSearchInputs.user.type]: () => {
      form.get(TroubleshootingSearchInputs.user.type)?.addValidators(Validators.required);
      form.get(TroubleshootingSearchInputs.org.type)?.addValidators(Validators.required);
    }
  };
};

/**
 * Get the search inputs based on the entity type.
 * @param type
 * @returns The corresponding entity input items.
 */
export const searchInputs = (type: string): EntityInput[] => {
  return {
    [TroubleshootingSearchInputs.product.type]: [TroubleshootingSearchInputs.product],
    [TroubleshootingSearchInputs.org.type]: [
      TroubleshootingSearchInputs.org
    ],
    [TroubleshootingSearchInputs.ogu.type]: [
      TroubleshootingSearchInputs.ogu,
      TroubleshootingSearchInputs.org
    ],
    [TroubleshootingSearchInputs.office.type]: [
      TroubleshootingSearchInputs.office
    ],
    [TroubleshootingSearchInputs.user.type]: [
      TroubleshootingSearchInputs.user,
      TroubleshootingSearchInputs.org,
      TroubleshootingSearchInputs.office
    ]
  }[type] ?? [];
};

/**
 * Get the component types based on the troubleshooting family.
 * @param family
 */
export const troubleshootingFamilyToComponentTypes =
    (family: TroubleshootingComponentFamily): ComponentType[] => {
  return {[TroubleshootingComponentFamily.SCRIPT]: [
    ComponentType.SMART_TOOL,
    ComponentType.SMART_CONTENT,
    ComponentType.OPEN_CONNECT
  ],
  [TroubleshootingComponentFamily.PARAMETERS]: [
    ComponentType.FUNCTIONAL_PARAM,
    ComponentType.ACTIVATION_PARAM,
    ComponentType.PERS_SETTINGS
  ]}[family] ?? [];
};

/**
 * Get the specific columns based on the troubleshooting family.
 * @param family
 */
export const troubleshootingFamilyToSpecificColumns =
    (family: TroubleshootingComponentFamily): string[] => {
  return {[TroubleshootingComponentFamily.SCRIPT]: [
    "url", "launchType", "modality", "httpsMethod", "componentContent"
  ],
  [TroubleshootingComponentFamily.PARAMETERS]: [
    "parameterName", "parameterValue"
  ]}[family] ?? [];
};

/**
 * Get the actor type based on the troubleshooting search type.
 * @param type
 */
export const troubleshootingSearchTypeToActorType = (type: string): ActorType => {
  return {
    [TroubleshootingSearchInputs.product.type]: ActorType.PRODUCT,
    [TroubleshootingSearchInputs.org.type]: ActorType.ORGANISATION,
    [TroubleshootingSearchInputs.ogu.type]: ActorType.OGU_ORGANISATION,
    [TroubleshootingSearchInputs.office.type]: ActorType.OFFICE,
    [TroubleshootingSearchInputs.user.type]: ActorType.USER_ORGANISATION
  }[type];
};
